<template>
  <div class='projects-widget' @click.stop='openLink'>
    <donut-widget
      :values='values'
      :labels='labels'
      :show-total=true
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DonutWidget from '@/components/Dashboard/DonutWidget.vue';

export default {
  name: 'AutomaticScansWidget',
  components: {
    DonutWidget,
  },
  props: {
    url: {
      required: false,
    },
  },
  methods: {
    openLink() {
      if (this.url) {
        this.$router.push(this.url);
      }
    },
    reduceData(obj) {
      return Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(obj).filter(([key, value]) => value !== 0),
      );
    },
  },
  computed: {
    ...mapGetters(['projectStatistics']),
    labels() {
      const labels = [];
      if (this.projectStatistics?.selection) {
        Object.keys(this.reduceData(this.projectStatistics?.selection)).forEach(key => labels.push(this.$t(`test.testType.${key}`)));
      }
      return labels;
    },
    values() {
      return this.projectStatistics?.selection ? Object.values(this.reduceData(this.projectStatistics.selection)) : [];
    },
  },
};
</script>

<style lang='scss' scoped>
.projects-widget {
  &:hover{
    cursor: pointer;
  }
}
</style>
